import React from 'react';

export default function InnerHeroBanner() {
  return (
    <div className='Inner-banner'>
      <img className="img-fluid" src={`${process.env.PUBLIC_URL}/img/famphy-inner-banner-services.jpg`} alt="Home Visits" />
    </div>
  );
}
